export default __webpack_public_path__ + "static/media/330.7c3c7c61.png";